import Header from "../components/Header";
import Footer from "../components/Footer";
import { Outlet, useLocation } from "react-router-dom";

const Layout = () => {
  const location = useLocation();
  const isHomePage = location.pathname === "/";

  return (
    <div className={!isHomePage ? "pt-24" : ""}>
      {!isHomePage && <Header />}
      <main className={!isHomePage ? "max-w-screen-xl mx-auto px-4 md:px-20 mt-10 pb-24 text-base whitespace-normal break-words" : ""}>
        <Outlet />
      </main>
      {!isHomePage && <Footer />}
    </div>
  );
};

export default Layout;
